Librarian.Modules.YouTube = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["loadPlayer", "loadVideo"], 

    options: {
        classPrefix: "modules-youtube-",
        // pick one:
        // a single video is embeded
        videoId: "",
        // a user's uploaded videos are embeded as a playlist
        username: "",
        // a playlist is embeded
        playlistId: ""
    },

    player: null, 

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    }, 

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        if (!this.containerEl)
            return;

        if (typeof YT !== "undefined")
            this.loadPlayer();
        else {
            Librarian.Modules.YouTube.loadAPI();

            window.addEvent("YouTubeIframeAPIReady", this.loadPlayer);
        }
    },

    loadPlayer: function() {
        // Create element to be transformed into iframe
        var videoContainer = new Element("div", {
            "class": (this.options.classPrefix || '') + "video"
        }).inject(this.containerEl);

        this.player = new YT.Player(videoContainer, {
            height: "100%",
            width: "100%",
            events: {
                onReady: this.loadVideo
            }
        });
    },

    loadVideo: function() {
        if (this.options.videoId) {
            // Embed video
            this.player.cueVideoById({
                videoId: this.options.videoId
            });
        }
        else if (this.options.username) {
            // Embed videos uploaded by a user
            this.player.cuePlaylist({ 
                listType: "user_uploads",
                list: this.options.username
            });
        }
        else if (this.options.playlistId) {
            // Embed videos from a playlist
            this.player.cuePlaylist({
                listType: "playlist",
                list: this.options.playlistId
            });
        }
    }
});

Librarian.Modules.YouTube.loadAPI = function() {
    var youtubeApiScript = $("youtubeApiScript");
    if (youtubeApiScript)
        return; // Script is already loaded or loading

    // Load youtube API javascript file
    Asset.javascript("https://www.youtube.com/iframe_api", {
        id: "youtubeApiScript"
    });

    window.onYouTubeIframeAPIReady = function() {
        window.fireEvent("YouTubeIframeAPIReady");
    }
} 